<section class="about-section">
  <h2 class="title">{{ 'about_jecrm' | translate }}</h2>
  <div class="container">
    <div class="image">
      <div class="img-wrapper">
        <img src="../../../../../assets/img/about.png" class="img-about" title="Про JECRM" alt="Про JECRM">
      </div>
    </div>
    <div class="about">
      <div>
        <p class="about__jecrm">
          {{ 'jecrm_is_a_crm' | translate }}
        </p>
      </div>
      <div>
        <h2 class="about__feature">{{ 'innovations' | translate }}</h2>
        <p class="about__description">
          {{ 'we_are_always' | translate }}
        </p>
      </div>
      <div>
        <h2 class="about__feature">{{ 'support' | translate }}</h2>
        <p class="about__description">
          {{ 'our_team_provides' | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
